import { render, staticRenderFns } from "./Bgreviewtwo.vue?vue&type=template&id=70b84504&scoped=true&"
import script from "./Bgreviewtwo.vue?vue&type=script&lang=js&"
export * from "./Bgreviewtwo.vue?vue&type=script&lang=js&"
import style0 from "./Bgreviewtwo.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Bgreviewtwo.vue?vue&type=style&index=1&id=70b84504&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b84504",
  null
  
)

export default component.exports